// Simple vanilla js animations (jQuery replacement)
//==================================================
(function (root, factory) {
    if (typeof define === "function" && define.amd) {
        define("animJs", factory(root));
    } else if (typeof exports === "object") {
        module.exports = factory(root);
    } else {
        root.animJs = factory(root);
    }
})(window || this, function (root) {

    "use strict";

    /**
     * Variables
     */

    const animJs = {};

    /**
     * Private methods
     */

    const getNodeElement = (el) => {
        if(el instanceof Element || el instanceof HTMLDocument)
            return el;

        const element = document.querySelector(el);
        if(typeof (element) !== undefined && element !== null)
            return el;
        else
            throw new Error('Provided element isn\'t valid one!');
    }

    const checkVisibility = (el) => {
        return el.style.display !== "none" && getComputedStyle(el, null).getPropertyValue('display') !== "none";
    }

    /**
     * Fade
     */

    animJs.fadeIn = (el, display) => {
        const animEl = getNodeElement(el);
        if(checkVisibility(animEl))
            return;

        animEl.style.opacity = 0;
        animEl.style.display = display || "block";

        (function fade() {
            let val = parseFloat(animEl.style.opacity);
            if (!((val += .1) > 1)) {
                animEl.style.opacity = val;
                requestAnimationFrame(fade);
            } else {
                animEl.style.removeProperty('opacity');
            }
        })();
    };

    animJs.fadeOut = (el) => {
        const animEl = getNodeElement(el);
        if(!checkVisibility(animEl))
            return;

        animEl.style.opacity = 1;

        (function fade() {
            if ((animEl.style.opacity -= .1) <= 0) {
                animEl.style.display = "none";
                animEl.style.removeProperty('opacity');
            } else {
                requestAnimationFrame(fade);
            }
        })();
    }

    animJs.fadeToggle = (el, state = null, display) => {
        const animEl = getNodeElement(el);
        let toggleState = !checkVisibility(animEl);

        if(state !== null)
            toggleState = state;

        if(toggleState)
            animJs.fadeIn(animEl, display || "block");
        else animJs.fadeOut(animEl);
    }

    /**
     * Slide
     */

    const clearAfterSlide = (el) => {
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition');
    }

    const defaultSlideDuration = 240;

    animJs.slideDown = (el, duration, callback = () => {}) => {
        const animEl = getNodeElement(el);
        if(checkVisibility(animEl) || animEl.clientHeight > 0)
            return;

        animEl.style.removeProperty('display');
        if(getComputedStyle(animEl, null).getPropertyValue('display') === "none")
            animEl.style.display = 'block';

        animEl.style.transition = 'height '+ (duration || defaultSlideDuration) +'ms ease-in-out';
        animEl.style.overflow = 'hidden';
        animEl.style.height = 'auto';

        const height = animEl.clientHeight + 'px';
        animEl.style.height = '0px';

        setTimeout(() => { animEl.style.height = height; }, 10);

        animEl.addEventListener('transitionend', () => {
            clearAfterSlide(animEl);
            callback();
        }, { once: true });
    }

    animJs.slideUp = (el, duration, callback = () => {}) => {
        const animEl = getNodeElement(el);
        if(!checkVisibility(animEl))
            return;

        if(!animEl.style.height)
            animEl.style.height = animEl.clientHeight + 'px';

        animEl.style.transition = 'height '+ (duration || defaultSlideDuration) +'ms ease-in-out';
        animEl.style.overflow = 'hidden';

        setTimeout(() => { animEl.style.height = '0px'; }, 10);

        animEl.addEventListener('transitionend', () => {
            animEl.style.display = 'none';
            clearAfterSlide(animEl);
            callback();
        }, { once: true });
    }

    animJs.slideToggle = (el, state = null, duration, callback = () => {}) => {
        const animEl = getNodeElement(el);
        let toggleState = !checkVisibility(animEl);

        if(state !== null)
            toggleState = state;

        if(toggleState)
            animJs.slideDown(animEl, duration, callback);
        else animJs.slideUp(animEl, duration, callback);
    }

    /**
     * Numbers
     */

    animJs.number = (el, duration = 4000) => {
        const match = el.innerHTML.match(/^(\d+)(.*)$/);
        const number = Number(match[1]),
            suffix = match[2],
            iteration = Math.max(Math.abs(Math.floor(duration / number)), 40);

        const startTime = new Date().getTime(),
            endTime = startTime + duration;

        let num, count = 0;
        el.innerHTML = count.toString();

        const interval = setInterval(() => {
            if(count === number)
                clearInterval(interval);

            const now = new Date().getTime(),
                remaining = Math.max((endTime - now) / duration, 0);

            count = Math.round(number - (remaining * number));

            num = count.toString();
            while (/(\d+)(\d{3})/.test(num))
                num = num.replace(/(\d+)(\d{3})/, '$1' + ' ' + '$2');

            el.innerHTML = num + (suffix ? suffix : '');
        }, iteration);
    };

    /**
     * Custom
     */

    animJs.custom = (el, type, value, unit, duration = 400) => {
        let start;
        const originValue = parseFloat(getComputedStyle(el, null)[type].replace(unit || "px", "")),
            valueFraction = value - originValue;

        requestAnimationFrame(function anim(timestamp) {
            if(start === undefined)
                start = timestamp;
            const elapsed = timestamp - start;

            el.style[type] = originValue + (valueFraction * (Math.min(elapsed, duration) / duration)) + (unit || 'px');

            if(elapsed < duration)
                requestAnimationFrame(anim);
        });
    }

    return animJs;
});